import { render, staticRenderFns } from "./UserTabStatements.vue?vue&type=template&id=7234947c&scoped=true"
import script from "./UserTabStatements.vue?vue&type=script&lang=js"
export * from "./UserTabStatements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7234947c",
  null
  
)

export default component.exports